<div class="grid-container">
    <!-- TITLE -->
    <div class="grid-description">
        <div class="grid-description-left">
            <teiasoft-title *ngIf="gridDescription" [size]="'medium'" [theme]="theme" [title]="gridDescription"
                class="title-margin"></teiasoft-title>
            <span *ngIf="title" class="settings-btn" (click)="showSettings()"><i class="fa-wrench fal"></i></span>
        </div>
        <ng-container *ngIf="gridDescriptionExtraTemplate">
            <ng-container [ngTemplateOutlet]="gridDescriptionExtraTemplate"
                [ngTemplateOutletContext]="gridDescriptionExtraContext"></ng-container>
        </ng-container>
    </div>
    <!-- GRID -->
    <div #teiasoftGrid class="teiasoft-grid tg-grid"
        [ngClass]="{'hide-me' : (!isLoaded || (pageDataSet.length == 0 && dataSet.length == 0))}">
        <div *ngIf="filterable" class="tg-filter">
            <input type="text" class="tg-input-filter" placeholder="{{'grid.filter' | translate}}"
                (keyup)="onKeyupFilter($event)" [(ngModel)]="searchedValue">
        </div>
        <div class="tg-content" style="display: flex; flex-direction: column; flex-grow: 1;overflow: auto;">
            <div class="tg-header">
                <!-- <span *ngIf="title" class="settings-btn" (click)="showSettings()"   ><i class="fa-wrench fal"></i></span> -->
                <div class="tg-row">
                    <!-- SPACE FOR SCROLLBAR -->
                    <div class="tg-sticky-container"
                        [style.width.px]="stickyContainerWidth > 0 ? stickyContainerWidth : null">
                        <div *ngIf="selectable" class="tg-ckb" style="margin-left: 0.2vw;">
                            <!-- <input *ngIf="multiSelection" type="checkbox" class="tg-ckb-input" (click)="onChckAllRowsClick()"> -->
                            <i *ngIf="multiSelection && selectedRows.length == 0" class="fal fa-square tg-ckb-input"
                                (click)="onSelectAllRows()"></i>
                            <i *ngIf="multiSelection  && selectedRows.length > 0 && selectedRows.length != pageDataSet.length"
                                class="fal fa-minus-square tg-ckb-input" (click)="onSelectAllRows()"></i>
                            <i *ngIf="multiSelection  && selectedRows.length == pageDataSet.length"
                                class="fal fa-check-square tg-ckb-input" (click)="onSelectAllRows()"></i>
                        </div>
                        <div *ngFor="let cCol of customIcoCols; let index = index" class="tg-custom-ico-cell">
                            <i *ngIf="cCol.action != 'deleteItem' && cCol.action != 'deleteUser'"
                                class="{{cCol.icon}} tg-custom-icon" [title]="getCustomColTitle(cCol.label!)"
                                (click)="onCustomIcoClick(cCol.action!, row)"></i>

                            <i *ngIf="cCol.action == 'deleteUser'" class="{{cCol.icon}} tg-custom-icon"
                                [title]="getCustomColTitle(cCol.label!)"
                                (click)="onCustomIcoClick(cCol.action!, row)"></i>

                            <i *ngIf="cCol.action == 'deleteItem' && pageDataSet.length > 1"
                                class="{{cCol.icon}} tg-custom-icon" [title]="getCustomColTitle(cCol.label!)"
                                (click)="onCustomIcoClick(cCol.action!, row)"></i>

                            <i *ngIf="cCol.action == 'deleteItem' && pageDataSet.length == 1"
                                class="{{cCol.icon}} tg-custom-icon-disabled"
                                [title]="getCustomColTitle(cCol.label!)"></i>
                            <i *ngIf="cCol.action == 'deleteUser'" class="{{cCol.icon}} tg-custom-icon-disabled"
                                [title]="getCustomColTitle(cCol.label!)"></i>
                        </div>
                        <div *ngIf="showEditIcon" class="tg-cell" [style.width.vw]="2.4">

                        </div>
                        <div *ngIf="showDeleteIcon" class="tg-cell" [style.width.vw]="2.4">

                        </div>
                    </div>

                    <div *ngFor="let col of gridColumns; let c=index;trackBy: trackByCol"
                        [class.sticky-column]="colIsSticky[c]" [style.left.px]="colLeftPx[c]" resizableColumn
                        [columnName]="col!" [gridConfiguration]="gridConfiguration" [resizingFlag]="resizingFlag"
                        [shouldRecalculate]="recalculateColumnsWidth" [resizeSelector]="resizeSelector"
                        [resizableColumnRedistribute]="autoWidth" (onColumnWidthUpdate)="onColumnWidthUpdate($event)"
                        [style.width.px]="getConfiguredColumnWidth(col)"
                        [style.min-width.px]="getConfiguredColumnWidth(col)"
                        [style.max-width.px]="getConfiguredColumnWidth(col)"
                        [style.flex-grow]="0" [style.flex-shrink]="0"
                        [style.flex-basis.px]="getConfiguredColumnWidth(col)"
                        class="tg-cell tg-header-cell" [id]="'tg-header_' + c"
                        [ngClass]="{'tg-header-sortable' : sortable}" (click)="onSortClick(col)">
                        <span class="tg-header-text" [style.margin-left]="'0.5vw'">
                            <ng-container *ngIf="!hasCustomHeaderRenderer(col)"> {{getColumnLabel(col,c)}}
                            </ng-container>
                            <!-- CUSTOM renderer -->
                            <ng-container *ngIf="hasCustomHeaderRenderer(col)">
                                <ng-container *ngIf="getCustomHeaderRenderer(col) as renderer">
                                    <ng-container [ngTemplateOutlet]="renderer.template"
                                        [ngTemplateOutletContext]="renderer.context"></ng-container>
                                </ng-container>
                            </ng-container>
                        </span><!-- [style.margin-left.vw]="0.5" -->
                        <span *ngIf="sortable" class="tg-sort-ico" [innerHtml]="getSortIcon(col)"></span>

                    </div>

                    <!-- SPACE FOR SCROLLBAR -->
                    <!-- <div *ngIf="scrollPosition != 'left'" class="tg-empty-forscroll"></div> -->
                </div>
            </div>
            <!-- FILTERS -->
            <div *ngIf="fullFilter" class="cnt-filter" [ngClass]="{'hide-me' : !openFilter}">
                <div class="tg-row" style="height:8vh; padding-bottom: 1vh;">
                    <div class="tg-sticky-container"
                        [style.width.px]="stickyContainerWidth > 0 ? stickyContainerWidth : null">
                        <div *ngIf="selectable" class="tg-ckb"></div>
                        <div *ngFor="let cCol of customIcoCols;trackBy: trackByCustomIco" class="tg-custom-ico-cell">
                        </div>
                        <div *ngIf="showEditIcon" class="tg-cell" [style.width.vw]="2.4"></div>
                        <div *ngIf="showDeleteIcon" class="tg-cell" [style.width.vw]="2.4"></div>
                    </div>

                    <div *ngFor="let filter of gridFilters.filters!; let f=index;trackBy: trackByFilter" class="tg-cell"
                        [id]="'tg-cell_f_' + f" [style.width.px]="getConfiguredColumnWidth(filter.dataField!)"
                        [style.min-width.px]="getConfiguredColumnWidth(filter.dataField!)"
                        [style.max-width.px]="getConfiguredColumnWidth(filter.dataField!)">

                        <!-- <span class="tg-cell-value" [style.width.vw]="(getColumnsWidth(filter.dataField!)-1.6)">test</span> -->

                        <teiasoft-input *ngIf="filter.dataType == 'string' || filter.dataType == 'any[]'" [size]="'s'"
                            (onInput)="onInputChangeFilter($event, filter.dataField!, filter.dataType!)"
                            [labelText]="'grid.contains' | translate" [clearValue]="clearFilters" [noMinWidth]="true"
                            [value]="getFilterValue(filter.dataField!)" style=" width:100%;"></teiasoft-input>
                        <!-- [style.width.vw]="(getColumnsWidth(filter.dataField!)-1.6)"  -->

                        <teiasoft-datetime *ngIf="filter.dataType == 'date'" [size]="'s'"
                            (onChange)="onChangeDataFilter($event, filter.dataField!)" [showQueryDirection]="true"
                            [clearValue]="clearFilters" [dateFormat]="dateFormat"
                            style="margin-bottom: 0.4vh;width:100%"
                            [value]="getFilterValue(filter.dataField!)"></teiasoft-datetime>
                        <!-- [style.width.vw]="(getColumnsWidth(filter.dataField!)-1.6)" -->
                    </div>
                </div>
            </div>
            <!-- (keydown)="onGridKeyDown($event)"  -->
            <div #tgBody class="tg-body-cnt" id="cntBodyGrid" [style.max-height.vh]="maxHeightVh"
                [ngClass]="{'scroll-left' :scrollPosition == 'left'}"> <!-- tabindex="0" -->
                <div *ngIf="virtualActive" class="tg-virtual-spacer" [style.height.px]="virtualPadTopPx"></div>
                <div *ngFor="let row of displayRows; let vi=index;trackBy: trackByAbsoluteIndex"
                    [ngClass]="{'tg-row-alternate' : isEven(vi + virtualStartIndex), 'tg-row-selectable': !selectable && !disableAllSelection, 'tg-row-active' : (!selectable && !disableAllSelection) && (selectedIndex == vi + virtualStartIndex),'row-left' :scrollPosition == 'left'}"
                    (click)="onRowClick($event,row,vi + virtualStartIndex)" class="tg-body-row">
                    <div class="tg-row">
                        <div #stickyContainer class="tg-sticky-container">
                            <div *ngIf="selectable && !disableAllSelection" class="tg-ckb">
                                <i *ngIf="checkIfImChecked(row, vi + virtualStartIndex)" class="fas fa-check-square tg-ckb-input"
                                    (click)="onChkSelectRowClick(row, vi + virtualStartIndex)" style="color:#232323; margin-left:0.2vw"></i>
                                <i *ngIf="!checkIfImChecked(row, vi + virtualStartIndex)" class="fal fa-square tg-ckb-input"
                                    (click)="onChkSelectRowClick(row, vi + virtualStartIndex)" style="color:#232323; margin-left:0.2vw"></i>

                                <!-- <input *ngIf="checkIfImChecked(row)" id="ckb_{{i}}" type="checkbox" class="tg-ckb-input" (click)="onChkSelectRowClick(row, i)" checked>
                    <input *ngIf="!checkIfImChecked(row)" id="ckb_{{i}}" type="checkbox" class="tg-ckb-input" (click)="onChkSelectRowClick(row, i)"> -->
                            </div>
                            <div *ngFor="let cCol of customIcoCols" class="tg-custom-ico-cell">
                                <i *ngIf="cCol.action != 'deleteItem' && cCol.action != 'deleteUser'"
                                    class="{{cCol.icon}} tg-custom-icon" [title]="getCustomColTitle(cCol.label!)"
                                    (click)="onCustomIcoClick(cCol.action!, row)"></i>

                                <i *ngIf="cCol.action == 'deleteUser' && !getUserLogged(row)"
                                    class="{{cCol.icon}} tg-custom-icon" [title]="getCustomColTitle(cCol.label!)"
                                    (click)="onCustomIcoClick(cCol.action!, row)"></i>

                                <i *ngIf="cCol.action == 'deleteItem' && pageDataSet.length > 1"
                                    class="{{cCol.icon}} tg-custom-icon" [title]="getCustomColTitle(cCol.label!)"
                                    (click)="onCustomIcoClick(cCol.action!, row)"></i>

                                <i *ngIf="cCol.action == 'deleteItem' && pageDataSet.length == 1"
                                    class="{{cCol.icon}} tg-custom-icon-disabled"
                                    [title]="getCustomColTitle(cCol.label!)"></i>
                                <i *ngIf="cCol.action == 'deleteUser' && getUserLogged(row)"
                                    class="{{cCol.icon}} tg-custom-icon-disabled"
                                    [title]="getCustomColTitle(cCol.label!)"></i>

                            </div>
                            <div *ngIf="showEditIcon" class="tg-cell align-center" [style.width.vw]="2.4">
                                <i class="fal fa-pencil-alt tg-custom-icon" (click)="onEditClick($event, row)"></i>
                            </div>
                            <div *ngIf="showDeleteIcon" class="tg-cell align-center" [style.width.vw]="2.4">
                                <i class="fal fa-trash-alt tg-custom-icon" (click)="onDeleteClick($event, row)"></i>
                            </div>
                        </div>
                        <div *ngFor="let col of gridColumns; let c=index" class="tg-cell" [id]="'tg-cell_' + c"
                            [class.sticky-column]="colIsSticky[c]" [style.left.px]="colLeftPx[c]"
                            [style.width.px]="getConfiguredColumnWidth(col)"
                            [style.min-width.px]="getConfiguredColumnWidth(col)"
                            [style.max-width.px]="getConfiguredColumnWidth(col)"
                            [ngClass]="{'clickable' : col.toLowerCase() == 'attachments' && row['attachments'] != ''}"
                            (click)="cellClick(col, row)">
                            <!-- SPAN NOT EDITABLE (plain text: no innerHTML sanitization, no tooltip directive) -->
                            <span
                                *ngIf="getValueType(row[col]) !== 'boolean' && (editableFields.indexOf(col) == -1) && !hasCustomRenderer(col) && !isCalculatedColumn(col)"
                                class="tg-cell-value"
                                (click)="onCalculateColClick(col, row)"
                                (contextmenu)="onCalculateColRightClick($event, col, row)" style="margin-left: 0.5vw;"
                                [ngClass]="{'span-highlight-big' : (columnsToHighlightBig.indexOf(col) != -1), 'span-highlight' : (columnsToHighlight.indexOf(col) != -1)}">{{getValue(row, col, row[col])}}</span>
                            <!-- SPAN NOT EDITABLE (calculated column: renders icon HTML, keeps tooltip) -->
                            <span
                                *ngIf="getValueType(row[col]) !== 'boolean' && (editableFields.indexOf(col) == -1) && !hasCustomRenderer(col) && isCalculatedColumn(col)"
                                class="tg-cell-value" [innerHTML]="getValue(row, col, row[col])" #tooltip="matTooltip"
                                [matTooltip]="getTooltipValue(row, col, row[col])"
                                (click)="onCalculateColClick(col, row)"
                                (contextmenu)="onCalculateColRightClick($event, col, row)" style="margin-left: 0.5vw;"
                                [ngClass]="{'span-highlight-big' : (columnsToHighlightBig.indexOf(col) != -1), 'span-highlight' : (columnsToHighlight.indexOf(col) != -1)}"></span>
                            <!-- ICON FOR BOOLEAN -->
                            <!-- <i *ngIf="getValueType(row[col]) === 'boolean' && row[col] == true && (editableFields.indexOf(col) == -1)"
                                            class="fal fa-check-circle green" style="margin-left: 0.5vw;"></i>
                                            <i *ngIf="getValueType(row[col]) === 'boolean' && row[col] === false && (editableFields.indexOf(col) == -1)"
                                            class="fal fa-times-circle" style="margin-left: 0.5vw;"></i> -->
                            <span
                                *ngIf="getValueType(row[col]) == 'boolean' && (editableFields.indexOf(col) == -1) && !hasCustomRenderer(col)"
                                class="tg-cell-value"
                                (click)="onCalculateColClick(col, row)" style="margin-left: 0.5vw;"
                                [ngClass]="{'span-highlight-big' : (columnsToHighlightBig.indexOf(col) != -1), 'span-highlight' : (columnsToHighlight.indexOf(col) != -1)}">{{getBooleanValue(row, col, row[col])}}</span>

                            <!-- EDITABLE -->
                            <div *ngIf="(editableFields.indexOf(col) != -1)" class="cnt-editable">
                                <input type="text" class="input-editable"
                                    (input)="onInputEditable($event, row, vi + virtualStartIndex, col)"
                                    [value]="row[col]">
                            </div>
                            <!-- CUSTOM renderer -->
                            <ng-container *ngIf="hasCustomRenderer(col)">
                                <ng-container *ngIf="getCustomRenderer(col, row) as renderer">
                                    <ng-container [ngTemplateOutlet]="renderer.template"
                                        [ngTemplateOutletContext]="renderer.context"></ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <!-- SUMMARY ROW -->
                    <div *ngIf="hasSummaryRow" class="row-summary">
                        <span class="span-summary"
                            [style.marginLeft.vw]="(!customIcoCols || customIcoCols!.length == 0 ? 0.5 : 3.4)">{{row['summary']}}</span>
                    </div>
                </div>
                <div *ngIf="virtualActive" class="tg-virtual-spacer" [style.height.px]="virtualPadBottomPx"></div>
            </div>
            <div class="tg-footer" *ngIf="showFooter">
                <div class="tg-footer-pager">
                    <span *ngIf="paginable && pageIndex > 1" class="tg-footer-span tg-link-arrow tg-sx"
                        (click)="onClickPageBack()">&#10094;</span>
                    <span *ngIf="paginable && pageIndex == 1"
                        class="tg-footer-span tg-link-arrow-disabled tg-sx">&#10094;</span>
                    <span *ngIf="paginable" class="tg-footer-span">{{'page' | translate}} {{pageIndex}} {{'of' |
                        translate}}
                        {{totPages}}</span>
                    <span *ngIf="paginable && pageIndex < totPages" class="tg-footer-span  tg-link-arrow tg-dx"
                        (click)="onClickPageForward()">&#10095;</span>
                    <span *ngIf="paginable && pageIndex == totPages"
                        class="tg-footer-span  tg-link-arrow-disabled tg-dx">&#10095;</span>
                </div>
                <div class="tg-footer-items">
                    <span *ngIf="paginable"
                        class="tg-footer-span span-margin">{{(((this.pageIndex-1)*this.rowsPerPage)+1)}}
                        -
                        {{getFooterCalcItems()}} {{'of' | translate}} </span>
                    <span class="tg-footer-span">{{dataSet.length}} {{'items' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- NO DATA  --> <!-- M.M 3.01.24 -->
    <div *ngIf="isLoaded && pageDataSet.length == 0" class="tg-nodata-grid">
        <!-- *ngIf="isLoaded && pageDataSet.length == 0" -->
        <span>{{'enquiryBook.noData' | translate}}</span>
    </div>
    <!-- PLACE HOLDER FOR LOADING -->
    <div *ngIf="showLoader && !isLoaded" class="tg-placeholder">
        <div class="tg-ico-loader">

        </div>
    </div>
</div>




<app-modal-feasibility-options *ngIf="showFeasibilityOptionsModal" [enquiryNo]="enquiryNo" [itemNo]="itemNo"
    [feasibilityStatus]="feasibilityStatus" (onCancel)="onCloseFeasibility($event)" [dataSet]="pageDataSet"
    [readOnly]="isModalReadOnly" (onOpenITDCR)="onOpenItdcrClick($event)">
</app-modal-feasibility-options>

<app-modal-feasibility-options-itdcr *ngIf="showFeasibilityOptionsItdcrModal" [enquiryNo]="enquiryNo" [itemNo]="itemNo"
    [feasibilitySource]="feasibilitySource"
    [feasibilitySourceDescription]="feasibilitySourceDescription" [readOnly]="isModalReadOnly"
    (onCancel)="onCloseFeasibility([])" (onSubmit)="onSubmitItdcrFeasibility($event)">
</app-modal-feasibility-options-itdcr>

<app-modal-price-options *ngIf="showModalPriceOptions" [enquiryNo]="enquiryNo" [itemNo]="itemNo"
    [item]="row" [origin]="origin" [rawMaterialGrade]="rawMaterialGrade" (onCancel)="onCloseModalPriceOptions($event)"
    [modalPriceOpenAs]="modalPriceOpenAs" [costsSourceCostingToolRecordId]="costsSourceCostingToolRecordId"
    [costsSourceCostingToolVersionId]="costsSourceCostingToolVersionId"
    [costsSourceDescription]="costsSourceDescription" [readOnly]="isModalReadOnly"
    (onOpenITDCR)="onOpenItdcrClick($event)"
    (onOpenCostingTool)="onOpenCostingToolModal($event)"></app-modal-price-options>

<app-modal-costing-tool *ngIf="showCostingToolModal" [enquiryNo]="enquiryNo" [item]="costingToolItem!"
    [origin]="costingToolOrigin" [useNearestMatch]="costingToolUseNearestMatch"
    [costsSourceCostingToolRecordId]="costingToolRecordId"
    [costsSourceCostingToolVersionId]="costingToolVersionId"
    [unitSystem]="costingToolUnitSystem"
    [currency]="costingToolCurrency"
    (onClose)="onCloseCostingToolModal()"></app-modal-costing-tool>

<app-modal-delivery-options *ngIf="showDeliveryOptionsModal" [readOnly]="isModalReadOnly" [item]="row"
    [enquiryNo]="enquiryNo" (onCancel)="onCloseModalDeliveryOptions($event)" (onOpenITDCR)="onOpenItdcrClick($event)"
    (onSaveDatesCollection)="onCloseModalDeliveryOptions($event)">
</app-modal-delivery-options>

<teiasoft-grid-settings *ngIf="showSettingsDialog" [gridConfiguration]="gridConfiguration"
    (onClose)="onCloseSettings($event)" (onApply)="onApplySettings($event)" [disableSortingCriteria]="true"
    [disableFreezeFeature]="false" [columnDisabled]="columnsToDisableInSettings"
    [customHeaderRenderers]="customHeaderRenderers"></teiasoft-grid-settings>
